import { useState } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";

import { CalendarioSelector, ConsultorioSelector, DarkButton, ModalContainer } from "../../../../../components";
import { CrearCitaAgendaModal } from "../../../../Modals/CrearCitaAgenda";
import { CrearEventoAgendaModal } from "../../../../Modals/CrearEventoAgenda";

import styles from './CalendarioSider.module.css';

export const CalendarioSider = () => {

  const location = useLocation();

  const { permisos } = useSelector(state => state.auth);

  const [statusCrearCitaModal, setStatusCrearCitaModal] = useState(false);

  const [statusCrearEventoModal, setStatusCrearEventoModal] = useState(false);

  const handleCrearCita = () => {
    setStatusCrearCitaModal(true);
  }

  const hideCancelarCrearCita = () => {
    setStatusCrearCitaModal(false);
  }

  const handleCrearEvento = () => {
    setStatusCrearEventoModal(true);
  }

  const hideCancelarCrearEvento = () => {
    setStatusCrearEventoModal(false);
  }

  return (
    <>
        <div className="row flex-grow-1">
            <div className={"col-sm-3 col-md-2 " + styles.sideContainer}>
                <CalendarioSelector />
                <ConsultorioSelector />
                {(location.pathname === '/agenda') &&
                <div>
                  {(permisos.citaCreate) && 
                  <DarkButton
                    block={true}
                    iconMargin={2}
                    iconSize="1.2"
                    icon="Plus"
                    inverse={false}
                    marginTop={false}
                    onClick={handleCrearCita}
                    text="Cita Nueva"
                    type="button"
                  />}
                  {(permisos.eventoCreate) &&
                  <DarkButton
                    block={true}
                    iconMargin={2}
                    iconSize="0.7"
                    icon="CalendarRange"
                    inverse={true}
                    marginTop={true}
                    onClick={handleCrearEvento}
                    text="Evento Nuevo"
                    type="button"
                  />}
                </div>
                }
            </div>
            <div className={"col " + styles.contentColumn}><Outlet /></div>
        </div>
        {(permisos.citaCreate && statusCrearCitaModal) &&
        <ModalContainer
          state={ statusCrearCitaModal }
          hide={ hideCancelarCrearCita }
          content={ <CrearCitaAgendaModal hide={ hideCancelarCrearCita } /> }
        />
        }
        {(permisos.eventoCreate && statusCrearEventoModal) &&
        <ModalContainer
          state={ statusCrearEventoModal }
          hide={ hideCancelarCrearEvento }
          content={ <CrearEventoAgendaModal hide={ hideCancelarCrearEvento } /> }
        />
        }
    </>
  )
}
